import React from 'react';
import Auxiliary from '../../util/Auxiliary';
import { Button, Card, Col, Input, Row, Select, message, DatePicker } from 'antd';

import FormItem from 'antd/es/form/FormItem';

import { Link } from 'react-router-dom';
import axios from '../../util/Api';
import moment from 'moment';
import { Formik, Form } from 'formik';
import DivisionForm from './DivisionForm';

const { RangePicker } = DatePicker;

const Create = (props) => {
  const { history } = props;

  return (
    <Auxiliary>
      <h1 className="title gx-mb-4">Registrasi Proyek Baru</h1>
      <Row>
        <Col xs={24} sm={24} md={24} lg={16}>

          <Card className="gx-card" title="Form Registrasi">
            <Formik
              initialValues={{
                name: '',
                division: undefined,
                code: '',
                manager: '',
                phone: '',
                email: '',
                date: ''
              }}
              onSubmit={values => {
                const start = values.date[0].format("YYYY-MM-DD");
                const end = values.date[1].format("YYYY-MM-DD");
                const url = `/project/create`;
                const data = { ...values, start: start, end: end };
                axios.post(url, data).then(({ data }) => {
                  if (data.success) {
                    message.success("Proyek baru telah berhasil dibuat",5);
                    history.push('/project');
                  } else {
                    message.error("Gagal menyimpan data proyek baru");
                  }
                }).catch(err => {
                  const resp = err.response;
                  message.error(resp);
                });
              }}
            >
              {(formik) => {
                console.log("formik.values: ",formik.values);
                return (
                  <Form onSubmit={formik.handleSubmit}>
                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Nama Proyek"
                    >
                      <Input name="name" onChange={formik.handleChange} autoFocus={true}/>
                    </FormItem>

                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Divisi Operasi"
                    >
                      <DivisionForm />
                    </FormItem>

                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Kode Proyek"
                    >
                      <Input name="code" onChange={formik.handleChange} />
                    </FormItem>

                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="PM / Manajer Proyek"
                    >
                      <Input name="manager" onChange={formik.handleChange} />
                    </FormItem>
                    
                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Email"
                    >
                      <Input name="email" onChange={formik.handleChange} />
                    </FormItem>
                    
                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Phone/WA Admin Proyek"
                    >
                      <Input name="phone" onChange={formik.handleChange} />
                    </FormItem>
                    
                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Mulai - Berakhir"
                    >
                      <RangePicker format="DD MMMM YYYY" onChange={(date) => {
                        formik.setFieldValue("date", date);
                      }}/>
                    </FormItem>

                    <FormItem
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      label="Status"
                    >
                      {formik.values.date ? <Status start={formik.values.date[0]} end={formik.values.date[1]} /> : null}
                    </FormItem>
                    <Row>
                      <Col span={8}></Col>
                      <Col span={16}>
                        <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>
                          Daftarkan Proyek
                        </Button>
                        <Link to="/project" className="ant-btn ant-btn-secondary gx-mb-0">
                          Kembali
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                );
              }}

            </Formik>
          </Card>
        </Col>
      </Row>
    </Auxiliary>
  );
}
export default Create;

const Status = ({ start, end }) => {
  return moment(new moment()).isBetween(start, end) ? "On Going" : moment(new moment()).isBefore(start) ? "Inactive" : "Completed";
}